import React from "react";
import {StyledDropDown} from "./MyStyledDropdown.styles";

export const MyStyledDropdown = ({children}) => {
    return <StyledDropDown>{children}</StyledDropDown>
}